import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { getAuthHeader } from '#lib/hooks/use-auth.jsx';
import useMutation from '#lib/hooks/use-mutation.js';
import { useState } from 'react';
import toast from 'react-hot-toast';

const postRefreshItinerary = async (itineraryId, connectionId) => {
    const authHeaders = await getAuthHeader();
    if (connectionId === 'tripsaround')
        return await fetchAndParse(`${API_URL}/p/publish/update`, {
            method: 'POST',
            headers: { ...jsonHeaders, ...authHeaders },
            body: JSON.stringify({ itineraryId, connectionId })
        });
    return await fetchAndParse(`${API_URL}/p/refresh`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify({ itineraryId, connectionId })
    });
};

export function useRefreshItinerary({ itineraryId, connectionId, onRefresh }) {
    const [refreshLoading, setRefreshLoading] = useState(false);
    const refreshItinerary = useMutation({
        mutationKey: ['refresh'],
        mutationFn: () => postRefreshItinerary(itineraryId, connectionId),
        onSuccess: (res) => {
            setRefreshLoading(false);
            if (res.ok) {
                onRefresh(res.itinerary);
            }
        },
        onError: (err) => {
            toast.error(err.message);
            setRefreshLoading(false);
        },
        invalidate: ['refresh'],
        enabled: false
    });

    return {
        refreshItinerary,
        refreshLoading,
        setRefreshLoading
    };
}
